import React, { Component } from "react";
import PageWrapper from "../../components/PageWrapper/PageWrapper";

class Admin extends Component {
  render() {
    return <PageWrapper admin context="protected">You are logged in.</PageWrapper>;
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/pages/Admin/Admin.js